<template>
  <div :class="col">
    <b-form-group
      id="senha"
      label-for="input-senha"
      :invalid-feedback="inputInvalid"
      :label="label"
      :class="col"
      :state="state"
    >
    <div class="input-group mb-3">
      <input
        id="password"
        :state="state"
        v-model.trim="password"
        class="form-control"
        :placeholder="inputText"
        :disabled="disabled"
        :type="inputType"
        :class="{
          'is-invalid': state === false,
          'is-valid': state === true
        }"
        @blur="validaTamanhoSenha"
      />
      <!-- REVELADOR DE SENHA -->
      <button
        class="btn btn-light btn-outline-secondary"
        type="button"
        @click="togglePassword()"
        v-if="mostraSenha"
        tabindex="-1"
      >
        <i v-if="isPassword" class="mdi mdi-eye-outline"></i>
        <i v-else class="mdi mdi-eye-off-outline"></i>
      </button>
    </div>
    </b-form-group>
  </div>
</template>

<script>


  export default {
    props: {
      col: String, // definindo o tamanho do input na tela de acordo com cada caso
      mostraSenha: Boolean, // botão para mostrar o input
      label: String, // para dar nome ao campo
      inputText: String, // placeholder
      inputInvalid: String, // mensagem para campo invalido
      disabled: Boolean, // para habilitar ou desabilitar o campo
      validado: Boolean // controla a cor dos campos
    },

    computed: {
      state() {
        if((this.validado || this.validado === false) && (this.estado === null || this.estado === false)){
          return this.validado
        }
        return this.estado
      },
      isPassword() {
        return this.inputType === "password";
      },
    },

    data() {
      return {
        inputType: 'password',
        password: '',
        estado: null
      }
    },

    methods: {
      togglePassword() {
        this.inputType = this.isPassword ? "text" : "password";
      },

      validaTamanhoSenha() {
        if(this.password.length < 3 ){
          if(this.password.length != 0 || this.validado === false ){
            this.estado = false
          } else {
            this.estado = null
          }
        } else {
          this.$emit("emitindoSenha", this.password);
          this.estado = true
        }
      },
    },


  }
</script>

